import {
    Menu, MenuItems, MenuButton, Transition, Switch
} from '@headlessui/react';
import {
    UserCircleIcon, InformationCircleIcon, AdjustmentsVerticalIcon,
    UserIcon, MoonIcon, SunIcon,
    FireIcon
} from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useI18n } from '../../i18n/i18nService';
import { useTheme } from '../../contexts/ThemeContext';

const UserBox = () => {
    const { user, logout } = useAuth();
    const { theme, toggleTheme } = useTheme();
    const { t } = useI18n();

    return (
        <Menu as="div" className="relative">
            {/* Menu Trigger */}
            <MenuButton className="flex items-center space-x-2 px-2 py-1 focus:outline-none md:px-4">
                <UserCircleIcon className="h-7 w-7 md:h-8 md:w-8 text-light-secondary dark:text-dark-secondary" />
                {/* <span className="hidden md:inline text-sm text-light-text dark:text-dark-text">
                    {user?.fullname || t('account')}
                </span> */}
            </MenuButton>

            {/* Menu Items */}
            <Transition
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 scale-90"
                enterTo="opacity-100 scale-100"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-90"
            >
                <MenuItems className="absolute right-0 mt-2 w-screen max-w-xs md:w-64 rounded-md bg-light-surface dark:bg-dark-bg shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                    <div className="p-4">
                        {/* Header */}
                        <div className="flex flex-col items-center text-center mb-4">
                            <UserCircleIcon className="h-10 w-10 mb-2 text-light-text dark:text-dark-text" />
                            <span className="text-sm text-light-text dark:text-dark-text font-medium">{user?.fullname || t('account')}</span>
                            <span className="text-xs text-light-text-muted dark:text-dark-text-muted">
                                {user?.roles.map(role => role.name).join(', ') || t('guest')}
                            </span>
                            <span className="text-xs text-light-text-muted dark:text-dark-text-muted">
                                {user?.email || t('no_email')}
                            </span>
                        </div>

                        <div className="space-y-2">
                            {/* Links */}
                            <Link to="/profile" className="menu-item">
                                <UserIcon className="h-5 w-5 text-light-text-muted dark:text-dark-text-muted" />
                                <span className="ml-2">{t('profile')}</span>
                            </Link>
                            <Link to="/settings" className="menu-item">
                                <AdjustmentsVerticalIcon className="h-5 w-5 text-light-text-muted dark:text-dark-text-muted" />
                                <span className="ml-2">{t('settings')}</span>
                            </Link>
                            <Link to="/help" className="menu-item">
                                <InformationCircleIcon className="h-5 w-5 text-light-text-muted dark:text-dark-text-muted" />
                                <span className="ml-2">{t('help')}</span>
                            </Link>

                            {/* Dark Mode Toggle */}
                            <div className="flex justify-between items-center px-2 py-2 rounded-md hover:bg-light-primary/10 dark:hover:bg-dark-primary/10">
                                <div className="flex items-center space-x-2">
                                    {theme === 'dark' ? (
                                        <SunIcon className="h-5 w-5 text-light-text-muted dark:text-dark-text-muted" />
                                    ) : (
                                        <MoonIcon className="h-5 w-5 text-light-text-muted dark:text-dark-text-muted" />
                                    )}
                                    <span className="text-sm text-light-text dark:text-dark-text">{t('dark_mode')}</span>
                                </div>
                                <Switch
                                    checked={theme === 'dark'}
                                    onChange={toggleTheme}
                                    className={`relative inline-flex h-6 w-11 items-center rounded-full ${theme === 'dark' ? 'bg-light-primary' : 'bg-gray-200'
                                        }`}
                                >
                                    <span
                                        className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${theme === 'dark' ? 'translate-x-6' : 'translate-x-1'
                                            }`}
                                    />
                                </Switch>
                            </div>

                            {/* Logout */}
                            <button
                                onClick={logout}
                                className="w-full flex items-center text-red-500 dark:text-red-400 rounded-md px-4 py-2 text-sm hover:bg-red-500/10"
                            >
                                <FireIcon className="h-5 w-5 mr-2" />
                                {t('logout')}
                            </button>
                        </div>
                    </div>
                </MenuItems>
            </Transition>
        </Menu>
    );
};

export default UserBox;
